
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { Router } from '@angular/router';
import { Product } from '../../models/product';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit ,AfterViewInit{
  @Input('product') product;
  @Input('currency') currency;

  
  cart: Product[];
  inCart: boolean = false;
  outOfStock: boolean = false;
  constructor(private cartService: ShoppingCartService ,private router : Router ,private dataService:DataService) { }

  ngOnInit() {
    if(this.product.stockQuantity === 0 && (!this.product.no_qty_limit) ){
      this.outOfStock = true ;
    }else{
      this.outOfStock = false;
    }

    this.getCartFromStorage();
    console.log("product:",this.product);

  }
  ngAfterViewInit(){
    this.dataService.cartItemsSubject.subscribe(cart =>{
      this.cart = cart ;
      this.getProductfromCart();

    })
  }

  addToCart(){
    this.cartService.add(this.product.id);
    this.product.quantity = 1;
    this.inCart = true;
    this.getCart()
  }

  getProductfromCart(){
    this.cart.filter(cartItem=>{
      if (cartItem.id === this.product.id){
        this.product.quantity = cartItem.quantity;
        this.inCart = true;
      }
    });
  }

  getCartFromStorage(){
    this.cart = this.cartService.cartItems;
    this.getProductfromCart();

  }


checkIfInCart(){
 let exist = this.cartService.find(this.product.id);
  console.log(exist);
}


  getCart(){
    this.dataService.cartItemsSubject.subscribe(cart =>{
      console.log(cart);
      this.cart.filter(cartItem=>{
        if (cartItem.id === this.product.id){
          this.product.quantity = cartItem.quantity;
          this.inCart = true;
        }
      });
    });

}
  buyNow(){
    this.cartService.add(this.product.id);
    this.router.navigate(['/checkout']);
  }
  viewProduct(){
    this.router.navigate([`/product/${this.product.slug}`],{
      queryParams:{
        qid: this.product.id,
      },
    })
  }
  moneyFormat(amount:number){
    return new Intl.NumberFormat().format(amount)
  }
}
